// /invite/:token — a barber or co-owner links their LINE account to the shop.
import { useState } from 'react';
import { useParams } from 'react-router';
import { ApiError } from '../api/client.ts';
import { useShop } from '../app/boot.tsx';
import { useShopPaths } from '../app/nav.tsx';
import { message } from '../lib/errors.ts';
import { Banner, Button, Card, Empty, Page } from '../ui/index.tsx';

export function Invite() {
  const { token = '' } = useParams();
  const { api, refreshMe, shop, me } = useShop();
  const { go } = useShopPaths();
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<{ code: string; text: string } | null>(null);

  if (me.staff && !done) {
    return (
      <Page title="เข้าร่วมเป็นพนักงาน">
        <Empty title="บัญชีนี้เป็นพนักงานของร้านอยู่แล้ว" action={{ label: 'ไปหน้าคิววันนี้', onClick: () => go('/staff/today') }} />
      </Page>
    );
  }

  async function accept() {
    setBusy(true);
    setError(null);
    try {
      await api.acceptInvite(token);
      await refreshMe();
      setDone(true);
    } catch (e) {
      setError({ code: e instanceof ApiError ? e.code : 'INTERNAL', text: message(e) });
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <Page title="เข้าร่วมเป็นพนักงาน">
        <div className="empty">
          <div className="empty-mark" aria-hidden="true">✓</div>
          <p className="empty-title">คุณเป็นพนักงานของร้านแล้ว</p>
          <p className="empty-text">เมนูใน LINE ของร้านจะเปลี่ยนเป็นเมนูพนักงาน (อาจต้องปิดแล้วเปิดแชทใหม่)</p>
          <Button onClick={() => go('/staff/today')}>ไปหน้าคิววันนี้</Button>
        </div>
      </Page>
    );
  }

  return (
    <Page title="เข้าร่วมเป็นพนักงาน">
      {error && (
        <Banner kind="error">
          {error.text}
          {error.code === 'INVITE_PROVIDER_MISMATCH' && <><br /><span className="small">เปิดแชท LINE ของร้าน กด “เพิ่มเพื่อน” แล้วเปิดลิงก์เชิญนี้อีกครั้ง</span></>}
        </Banner>
      )}
      <Card>
        <p>คุณได้รับเชิญให้เป็นพนักงานของ <b>{shop.name}</b></p>
        <p className="muted small" style={{ marginTop: 6 }}>บัญชี LINE นี้จะเห็นคิวและจัดการการจองของร้านได้</p>
      </Card>
      <div style={{ height: 16 }} />
      <Button block loading={busy} onClick={() => void accept()}>ยืนยันเข้าร่วมเป็นพนักงาน</Button>
    </Page>
  );
}
